module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-crocs-5fceec4a2e14c5b027c737225dd136c6.svg";